module.exports = __webpack_public_path__ + "static/img/patriarch.87b93cf2.png";